import { render } from "./JieSuanDetail.vue?vue&type=template&id=5ffa06a3&scoped=true"
import script from "./JieSuanDetail.vue?vue&type=script&lang=js"
export * from "./JieSuanDetail.vue?vue&type=script&lang=js"

import "./JieSuanDetail.vue?vue&type=style&index=0&id=5ffa06a3&lang=less&scoped=true"
import "./JieSuanDetail.vue?vue&type=style&index=1&id=5ffa06a3&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffa06a3"]])

export default __exports__